/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import type {} from '@redux-devtools/extension'; // required for devtools typing

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { createMenuSlice, MenuSlice } from '@/state/menuSlice';

import { createJobBannersSlice, JobBannersSlice } from './jobBannersSlice';
import { createSetupCLISlice, SetupCLISlice } from './setupCLISlice';
import { createSubtenantsHierarchySlice, SubtenantsHierarchySlice } from './subtenantsHierarchySlice';
import { createSubtenantSwitcherSlice, SubtenantSwitcherSlice } from './subtenantSwitcherSlice';
import { createThemeSlice, ThemeSlice } from './themeSlice';
import { createToastMessagesSlice, ToastMessagesSlice } from './toastMessagesSlice';
import { createUserProfileSlice, UserProfileSlice } from './userProfileSlice';
import { createWebsocketSlice, WebsocketSlice } from './websocketSlice';

export type MgmtPlaneState = ToastMessagesSlice &
  UserProfileSlice &
  SetupCLISlice &
  WebsocketSlice &
  ThemeSlice &
  MenuSlice &
  SubtenantsHierarchySlice &
  SubtenantSwitcherSlice &
  JobBannersSlice;

export const useMgmtPlaneStateStore = create<MgmtPlaneState>()(
  devtools((...a) => ({
    ...createUserProfileSlice(...a),
    ...createSetupCLISlice(...a),
    ...createToastMessagesSlice(...a),
    ...createWebsocketSlice(...a),
    ...createThemeSlice(...a),
    ...createMenuSlice(...a),
    ...createSubtenantsHierarchySlice(...a),
    ...createSubtenantSwitcherSlice(...a),
    ...createJobBannersSlice(...a),
  })),
);

export * from './setupCLISlice';
export * from './themeSlice';
export * from './toastMessagesSlice';
export * from './userProfileSlice';
export * from './websocketSlice';
export * from './subtenantSwitcherSlice';
